import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { VideoCallService } from '../video-call/video-call.service';

@Component({
  selector: 'tn-end-video-call-prompt',
  templateUrl: './end-video-call-prompt.component.html',
  styleUrls: ['./end-video-call-prompt.component.scss']
})
export class EndVideoCallPromptComponent implements OnInit {
  isRequestToStart: boolean = false;
  openVideoCallWindow: Function = null;

  closeVideoCallWindow: Function = null;
  isCheckVideoCallStatus: Function = null;

  constructor(
    public dialogRef: MatDialogRef<EndVideoCallPromptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _videoCallService: VideoCallService,
  ) { }

  ngOnInit() {
    // console.log(this.data)
    this.isRequestToStart = this.data.isRequestToStart

    if (this.isRequestToStart && this.data.openVideoCallWindow) {
      this.openVideoCallWindow = this.data.openVideoCallWindow;
    } 

    if (!this.isRequestToStart) {
      if (!this.data.closeVideoCallWindow || !this.data.isCheckVideoCallStatus) {
        return
      }

      this.closeVideoCallWindow = this.data.closeVideoCallWindow;
      this.isCheckVideoCallStatus = this.data.isCheckVideoCallStatus
    }
  }

  startVideoCallSession(): void {
    if (this.data) {
      let { chat_id, isGroup, user_id } = this.data

      this._videoCallService.beginVideoCall(
        chat_id,
        isGroup,
        user_id,
        this.openVideoCallWindow
      )
    }
  }


  stopVideoCallSession(): void {
    if (!this.data) {
      return
    }

    let { isCallByMe, isGroup } = this.data

    if (this.closeVideoCallWindow) {
      this.closeVideoCallWindow()
    }

    if (isGroup) {
      if (isCallByMe) {
        this._videoCallService.endVideoCall(this.data.goToChatCallBack)
      } else {
        // just clear own video call info
        this._videoCallService.initVideoCallInfo(this.data.goToChatCallBack)
      }
    } else {
      this._videoCallService.endVideoCall(this.data.goToChatCallBack)
    }

    // this.isCheckVideoCallStatus();
  }
}
